export default function ServiceRenderer({
  data,
  className,
}: {
  data: {
    title?: string;
    prepearing?: string;
    expertise?: string;
    validity?: string;
    sum?: string;
    button?: string;
    link?: string;
  };
  className?: string;
}) {
  try {
    const { title, prepearing, expertise, validity, sum, link, button } = data;

    return (
      <article className="widget service">
        <div className="widget__body service__body">
          <strong className="service__title">{title}</strong>
          <div className="service__row">
            <p className="service__row-item">
              Подготовка{" "}
              <span className="service__prepearing">{prepearing}</span>
            </p>
            <p className="service__row-item">
              Экспертиза <span className="service__expertise">{expertise}</span>
            </p>
            <p className="service__row-item">
              Срок действия{" "}
              <span className="service__validity">{validity}</span>
            </p>
          </div>
          <div className="service__row-bottom">
            <strong className="service__sum">{sum}&nbsp;₽</strong>
            <a
              href={link}
              className="btn btn-fond black scale-up service__button"
            >
              <i className="btn__text">{button}</i>
              <span className="icon icon-arrow-btn btn__icon" />
            </a>
          </div>
        </div>
      </article>
    );
  } catch (error) {
    console.info(`Не удалось отобразить виджет Service: ${error}`);
    return <></>;
  }
}
